import {
  CREATE_ALGO_PAGE_LOADED_FALSE,
  CREATE_ALGO_PAGE_LOADED_TRUE,
} from '../../constants/ActionTypes';

const createAlgo = (
  state = {
    pageLoaded: false,
  },
  action
) => {
  switch (action.type) {
    case CREATE_ALGO_PAGE_LOADED_FALSE:
      return { ...state, pageLoaded: false };
    case CREATE_ALGO_PAGE_LOADED_TRUE:
      return { ...state, pageLoaded: true };
    default:
      return state;
  }
};

export default createAlgo;
